/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEmojiSmile = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2zm0 2c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm-3.254 9.334c.973 1.09 2.1 1.666 3.26 1.666h.008c1.157-.002 2.276-.577 3.237-1.663l1.498 1.326c-1.332 1.504-3.012 2.333-4.732 2.337h-.01c-1.722 0-3.41-.829-4.753-2.334zM10.01 8v2H8V8zM16 8v2h-2.01V8z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEmojiSmile as EmojiSmile };
